import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.9999 19C12.9999 19.5523 12.5522 20 11.9999 20C11.4476 20 10.9999 19.5523 10.9999 19L10.9999 5C10.9999 4.44772 11.4476 4 11.9999 4C12.5522 4 12.9999 4.44772 12.9999 5L12.9999 19Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M19.707 11.293C20.0975 11.6835 20.0975 12.3165 19.707 12.707L12.707 19.707C12.3164 20.0976 11.6834 20.0976 11.2929 19.707L4.29289 12.707C3.90237 12.3165 3.90237 11.6835 4.29289 11.293C4.68342 10.9024 5.31643 10.9024 5.70696 11.293L11.9999 17.5859L18.2929 11.293C18.6834 10.9024 19.3164 10.9024 19.707 11.293Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }